import React from 'react';

const Loading = () => {
  const loadingStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '30px',
    width: '100%'
  };

  const spinnerStyle = {
    display: 'inline-block',
    width: '40px',
    height: '40px',
    border: '4px solid rgba(0, 0, 0, 0.1)',
    borderRadius: '50%',
    borderTopColor: '#007bff',
    animation: 'spin 1s linear infinite'
  };

  return (
    <div className="loading-container" style={loadingStyle}>
      <div className="spinner" style={spinnerStyle}></div>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Loading;
